import { render, staticRenderFns } from "./OidcConsentView.vue?vue&type=template&id=4f7a1fce&scoped=true&"
import script from "./OidcConsentView.vue?vue&type=script&lang=ts&"
export * from "./OidcConsentView.vue?vue&type=script&lang=ts&"
import style0 from "./OidcConsentView.vue?vue&type=style&index=0&id=4f7a1fce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7a1fce",
  null
  
)

export default component.exports